var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhMoins(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 53.336,
    height: 53.336,
    viewBox: "0 0 53.336 53.336",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26",
    "data-name": "Rectangle 26",
    width: 53.336,
    height: 53.336,
    rx: 15,
    fill: "#e0057f",
    opacity: 0.3
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_229",
    "data-name": "Rectangle 229",
    width: 33.195,
    height: 27.791,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_341",
    "data-name": "Groupe 341",
    transform: "translate(173 -2831.938)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_327",
    "data-name": "Groupe 327",
    transform: "translate(-173 2831.938)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_238",
    "data-name": "Groupe 238",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_de_masques_40",
    "data-name": "Groupe de masques 40",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25",
    "data-name": "Rectangle 25",
    width: 53.336,
    height: 53.336,
    transform: "translate(0 0)",
    fill: "#e0057f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_213",
    "data-name": "Groupe 213",
    transform: "translate(8.959 20.896)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_212",
    "data-name": "Groupe 212",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_290",
    "data-name": "Trac\\xE9 290",
    d: "M168.34,27.745a.85.85,0,0,1-.85-.85V.85a.85.85,0,0,1,1.7,0V26.895a.85.85,0,0,1-.85.85",
    transform: "translate(-151.67 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_291",
    "data-name": "Trac\\xE9 291",
    d: "M66.209,9.459a.85.85,0,0,1-.22-1.671L85.427,2.579a.85.85,0,0,1,.44,1.642L66.43,9.43a.851.851,0,0,1-.221.029",
    transform: "translate(-59.186 -2.309)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_292",
    "data-name": "Trac\\xE9 292",
    d: "M207.149,17.355A.85.85,0,0,1,206.4,16.1l6.222-11.527a.85.85,0,0,1,1.509.025l5.691,11.431a.85.85,0,0,1-.754,1.229l-11.913.1ZM213.34,6.824l-4.76,8.819,9.115-.074Z",
    transform: "translate(-186.813 -3.738)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_293",
    "data-name": "Trac\\xE9 293",
    d: "M.851,70.992A.85.85,0,0,1,.1,69.738L6.324,58.211a.85.85,0,0,1,1.509.025l5.691,11.431a.85.85,0,0,1-.754,1.229l-11.913.1ZM7.042,60.461,2.282,69.28l9.115-.074Z",
    transform: "translate(-0.001 -52.309)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_294",
    "data-name": "Trac\\xE9 294",
    d: "M6.71,182.437a10.874,10.874,0,0,1-2.524-.3A10.855,10.855,0,0,1,.328,180.4a.85.85,0,0,1,1.043-1.343A9.346,9.346,0,0,0,4.649,180.5a9.471,9.471,0,0,0,7.641-1.571.85.85,0,1,1,.948,1.411,11.56,11.56,0,0,1-6.528,2.1",
    transform: "translate(0 -161.899)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_295",
    "data-name": "Trac\\xE9 295",
    d: "M214.029,130.841a11.146,11.146,0,0,1-6.382-2.034.85.85,0,0,1,1.043-1.343,9.345,9.345,0,0,0,3.278,1.441,9.471,9.471,0,0,0,7.641-1.571.85.85,0,0,1,.948,1.411,11.56,11.56,0,0,1-6.528,2.1",
    transform: "translate(-187.737 -115.176)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_296",
    "data-name": "Trac\\xE9 296",
    d: "M102.487,277.934H87.149a.85.85,0,1,1,0-1.7h15.337a.85.85,0,1,1,0,1.7",
    transform: "translate(-78.148 -250.143)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_243",
    "data-name": "Groupe 243",
    transform: "translate(38.027 14.832)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_12",
    "data-name": "Ellipse 12",
    d: "M4.127,1A3.127,3.127,0,1,0,7.254,4.127,3.131,3.131,0,0,0,4.127,1m0-1A4.127,4.127,0,1,1,0,4.127,4.127,4.127,0,0,1,4.127,0Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ligne_6",
    "data-name": "Ligne 6",
    d: "M2.4.517h0L0,.5A.5.5,0,0,1-.5,0,.5.5,0,0,1,0-.5l2.4.017a.5.5,0,0,1,0,1Z",
    transform: "translate(2.871 4.118)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "pH",
    d: "M.925,11.08q-.1,0-.173-.071t-.071-.173V4.107q0-.1.071-.173t.173-.071h.8q.112,0,.178.071t.066.173v.407q.244-.325.64-.539T3.6,3.761q.539,0,.935.173t.661.493q.264.32.407.757t.163.966q.01.173.01.356t-.01.366q-.01.508-.152.94T5.2,8.564q-.269.32-.666.5T3.6,9.25q-.549,0-.935-.2t-.63-.524v2.307q0,.1-.066.173t-.178.071Zm2.3-2.917q.437,0,.681-.188t.351-.493q.107-.3.127-.671.02-.3,0-.61-.02-.366-.127-.671T3.9,5.037q-.244-.188-.681-.188-.417,0-.676.193t-.376.493q-.117.3-.137.615-.01.183-.01.386t.01.4q.01.3.142.584t.386.463Q2.816,8.163,3.222,8.163Zm4.056.986a.282.282,0,0,1-.049,0,.244.244,0,0,1-.045-.012.235.235,0,0,1-.041-.021.253.253,0,0,1-.037-.029q-.071-.066-.071-.178V2.287q0-.112.071-.183t.173-.071H8.2q.112,0,.178.071t.066.183V4.91h3V2.287q0-.112.071-.183t.173-.071H12.6q.112,0,.183.071t.071.183V8.9q0,.1-.071.173a.24.24,0,0,1-.038.031.231.231,0,0,1-.043.022.253.253,0,0,1-.048.013.309.309,0,0,1-.053,0H11.69a.263.263,0,0,1-.049,0,.228.228,0,0,1-.086-.036.257.257,0,0,1-.037-.031q-.071-.071-.071-.173V6.18h-3V8.9q0,.1-.066.173a.216.216,0,0,1-.036.031.212.212,0,0,1-.042.022.24.24,0,0,1-.047.013.3.3,0,0,1-.053,0Z",
    transform: "translate(19.266 2.012)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhMoins);
export default __webpack_public_path__ + "static/media/PH_MOINS.60325b45c8b4c3beb8c0110fcc24fdd9.svg";
export { ForwardRef as ReactComponent };